import { msg, optionalEmailSchema, optionalPhoneSchema } from '~/utils/validation';
import { CompetitionCategoryEnum } from '~/apis/ssf';
import { z } from 'zod';

export const schema = z
  .object({
    name: z
      .string()
      .min(1, { message: msg.required })
      .max(35, { message: 'Tävlingsnamnet får inte vara längre än 35 tecken' }),
    category: z
      .string()
      .min(1, { message: msg.required })
      .transform(arg => arg as CompetitionCategoryEnum),
    start_date: z.string().date(msg.date),
    end_date: z.string().date(msg.date),
    reg_deadline: z.union([z.string().date(msg.date), z.literal('')]).transform(n => (n ? n : undefined)),
    location: z.string().optional(),
    districts: z.array(z.number()).optional(),
    organizer: z.string().min(1, { message: msg.required }),
    contact_first_name: z.string().optional(),
    contact_last_name: z.string().optional(),
    contact_email: optionalEmailSchema,
    contact_phone: optionalPhoneSchema,
    payment_info: z.string().optional(),
    files: z.array(z.string()).default([]),
    open_externally: z.boolean(),
    is_team_comp: z.boolean().default(false),
    registrations_limit: z
      .union([z.literal(''), z.null(), z.coerce.number().int().min(0)])
      .optional()
      .transform(v => (v === '' || v === null || v === undefined ? null : v)),
    admins: z.array(z.string()),
  })
  // Ensure start date is before or equal to end date
  .refine(({ start_date, end_date }) => new Date(end_date) >= new Date(start_date), {
    message: 'Slutdatum kan inte vara innan startdatumet',
    path: ['end_date'],
  })
  // Ensure registration deadline is before start date
  .refine(({ start_date, reg_deadline }) => (reg_deadline ? new Date(reg_deadline) < new Date(start_date) : true), {
    message: 'Sista anmälningsdag måste vara innan startdatumet',
    path: ['reg_deadline'],
  });

export type Schema = z.infer<typeof schema>;
